module.exports = __webpack_public_path__ + "img/BOSNewTwo.2d96b057.gif";